<div class="readonly-form-field-container">
  <div
    class="form-input-label"
    [class.disabled]="disabled()">
    {{ label() }}
  </div>
  <lib-loading-shimmer [showLoading]="loading()">
    <div
      class="readonly-form-field-value"
      [class.disabled]="disabled()"
      [class.has-trailing-icon]="trailingIconName()"
      [class.loading]="loading()">
      {{ value() ?? '&nbsp;' }}
    </div>
    @if (trailingIconName()) {
      <mat-icon
        class="trailing-icon"
        (click)="trailingIconClick.emit()"
        [svgIcon]="trailingIconName() ?? ''">
      </mat-icon>
    }
  </lib-loading-shimmer>
  @if (hintText()) {
    <div class="form-input-hint-label" [class.disabled]="disabled()">
      {{ hintText() }}
    </div>
  }
</div>
